<template>
<div>

  <div style="color: white;background:black;position:fixed;top:0;left:0;z-index:999999;">
    <div class="w-grid">
    <div class="w-1-5 hidden-sm hidden-md hidden-lg hidden-xl">XS</div>
    <div class="w-1-5 hidden-xs hidden-md hidden-lg hidden-xl">SM</div>
    <div class="w-1-5 hidden-xs hidden-sm hidden-lg hidden-xl">MD</div>
    <div class="w-1-5 hidden-xs hidden-sm hidden-md hidden-xl">LG</div>
    <div class="w-1-5 hidden-xs hidden-sm hidden-md hidden-lg">XL</div>
    </div>
  </div>

 
 <transition name="fade" mode="out-in">
  <router-view></router-view>
 </transition>
      
  
</div>
</template>

<script>



export default {
  name: 'App',
  components: {
   
  },
  data () {
    return {
      
    }
  },
  computed: {
    regInvalid() {
      return this.$store.getters.regInvalid
    } 
  },
  methods: {
    setRegInvalid() {
      this.$store.dispatch('setRegInvalid', false)
    }
  }
  
}
</script>
<style type="text/css">
.fade-enter-active{
  transition: opacity 0.3s;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
 
}

body{
  overflow-x:hidden;
}
h1{
    font-size: 38px;
    line-height: 38px;
    text-transform: uppercase;
}

h2{
  font-size: 38px;
    line-height: 38px;
    text-transform: uppercase;
}



.color-white{ color: #FFFFFF;}
.bg-white{ background-color: #FFFFFF; }
.color-black{ color: #000000;}
.bg-black{ background-color: #000000;}
.color-blue{ color: #008EC8;}
.bg-blue{ background-color: #008EC8; }
.color-grey{ color: #B5B5B5;}
.bg-grey{ background-color: #B5B5B5;}
.color-dkgrey{ color: #999999;}
.bg-dkgrey{ background-color: #999999;}
.color-red{ color: red; }
.hero{
  background-image:url(./assets/images/hero-cars-top-right.png);
  background-position:top right;
  background-size: 25%;
}

.m4c-btn{
  opacity: 1;
    position: relative;
    height: 70px;
    border-radius: 70px;
    padding: 5px 32px;
    background-color: #29AAE4;
    border: 6px solid #29AAE4;
    font-size: 36px;
    line-height: 36px;
    font-weight: 800;
    text-align: center;
}

.m4c-btn.charcoal{
    background-color: #666666;
    border: 6px solid #666666;
}

.m4c-btn:before, 
.m4c-btn:after{
    position: absolute;
    content: "";
    top:0;
    left: 0;
    border-radius: 50px;
    height: 100%;
    width: 100%;
    -webkit-box-shadow: inset 0px 2px 2px 0px rgba(255, 255, 255, 0.6);
    -moz-box-shadow:    inset 0px 2px 2px 0px rgba(255, 255, 255, 0.6);
    box-shadow:         inset 0px 2px 2px 0px rgba(255, 255, 255, 0.6);
}

.m4c-btn:after{
    bottom: 0;
    top: unset;
    -webkit-box-shadow: inset 0px -2px 2px 0px rgba(0,0,0, 0.6);
    -moz-box-shadow:    inset 0px -2px 2px 0px rgba(0,0,0, 0.6);
    box-shadow:         inset 0px -2px 2px 0px rgba(0,0,0, 0.6);
}

.m4c-btn:disabled{
  opacity: 0.6;

}

.m4c-textbox{
    position: relative;
    margin-bottom: 20px;
}

.m4c-textbox input{
    border-radius: 50px;
    padding: 10px 20px;
    height: 50px;
    font-size: 21px;
    line-height:21px;
    border: 5px solid #EDEDED;
    background-color: #F9F9F9;
     -webkit-box-shadow: inset 0px 2px 5px 0px rgba(0,0,0, 0.2);
    -moz-box-shadow:    inset 0px 2px 5px 0px rgba(0,0,0, 0.2);
    box-shadow:         inset 0px 2px 5px 0px rgba(0,0,0, 0.2);

}

.m4c-textbox input:focus{
    border-color: #29AAE4;
}

.m4c-textbox input.input-warning{
    border-color: red;
}

.m4c-textbox.has-success:after{
    content: "";
  position: absolute;
  top: 10px;
    right: 10px;
  background-image:url(./assets/images/green-tick.png);
  background-size: 100%;
  z-index: 999;
  width: 32px;
  height: 32px;
}



input:-internal-autofill-previewed, 
input:-internal-autofill-selected, 
textarea:-internal-autofill-previewed, 
textarea:-internal-autofill-selected, 
select:-internal-autofill-previewed, 
select:-internal-autofill-selected{
  background: transparent!important;
}

.car-details-form .w-grid .w-grid > div{
  font-size: 24px;
  line-height: 50px;
  
}



.question{
    display:flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.question.top{
    align-items: flex-start;
}

.question > .q-field{
    display:flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
}

.question > .q-field > .m4c-textbox{
    margin: 0;
    margin-right: 20px;
    width: 300px;
}

.question > .q-field #description{
    width: 480px;
}

@media screen and (max-width: 35.4em) { /* xs */

    h1, h2, h2.car-title, .home h1{
      font-size: 32px;
      line-height: 32px;
    }

    .hero{
      background-image: none;
    }

    h3.hero-subheading{
      font-size: 24px;
      line-height: 24px;
    }
    .question{
        flex-flow: column wrap;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .question > .q-title{
        margin-bottom: 10px;
    }
    
    .question > .q-field{
        display:flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .question > .q-field #description{
        width: 320px;
    }

    p.rating-description{
        margin-bottom: 50px;
        font-size: 15px;
        line-height: 18px;
    }

    .m4c-input, button.m4c-btn, button.m4c-btn.get-cash-offer{
      width: 260px;
      padding: 0px;
      font-size: 26px;
    }
}

.question > .q-field > .btn-radio span{
    font-size: 20px;
    padding-left: 48px;
}

.question > .q-title{
    
    font-size: 23px;
    line-height: 23px;
    font-weight: bold;
}

.question p{
    text-align:left;
    font-size: 18px;
    color:#333;
    margin-top:10px;
}
</style>
